/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import DataVaxiomInsuranceCarrierForm from 'DesignSystem/DataVaxiomInsuranceCarrierForm/index'
import React from 'react'
import SaveConfirm from './SaveConfirm/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/Carrier/Content/Options/Edit/Content/EditInsurance/Content"
  
}) {
  return (<React.Fragment
>
<DataVaxiomInsuranceCarrierForm
  viewPath={`${viewPath}/DataVaxiomInsuranceCarrierForm`}
/>
<SaveConfirm
  viewPath={`${viewPath}/SaveConfirm`}
/>
{children}
</React.Fragment>)
}